import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { COUNTRY_CODE } from '../../fields';
import { COUNTRY_VIDEO_REPORT_ID } from './countryVideoReportId';

const countryReportFooterColumnDefinition = [COUNTRY_CODE].map(createFooterMapper(COUNTRY_VIDEO_REPORT_ID));

export default countryReportFooterColumnDefinition;
